import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { THEME, type TTheme } from 'constants/interfaces';

import type ITheme from './interfaces/ITheme';

export const initialState: ITheme = {
  theme: THEME.light,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => ({ theme: state.theme === THEME.light ? THEME.dark : THEME.light }),
    setTheme: (_state, action: PayloadAction<TTheme>) => ({ theme: action.payload }),
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;

export default themeSlice.reducer;
